import { useState } from 'react'
import { Box, useTheme } from '@mui/material';
import Header from '../../../component/Dashboard/Header';
import Profile from "../../../Assets/Images/General/avatar.jpg";
import { Link } from 'react-router-dom';
import CustomModal from "../../../component/Global/Modal/task_modal";
import { tokens } from "../../../theme";

function Task() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);


  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // styles 
  const style = {
    "& .content-page": {
      marginLeft: "0 !important",
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
      marginRight: "0 !important"
    },
    "& .card": {
      backgroundColor: colors.primary[400],
      color: colors.grey[200],
    },
    ".taskList > li": {
      backgroundColor: colors.primary[500],
      color: colors.grey[100],
      border: `1px solid ${colors.grey[500]}`
    },
    "& h4": {
      color: colors.grey[100],
      paddingLeft: "0.5rem"
    },
    "& .text-dark": {
      color: `${colors.grey[100]} !important`,

    },
  }

  return (
    <section className="task-section">
      <Box mt={13} ml={4.6} mr={4} sx={style} >
        <Header title="Task" subtitle="You can manage all your activities and task here" />
        <div className="content-page">
          <div className="content">
            {/* Start Content*/}
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-4">
                  <div className="card">
                    <div className="card-body taskboard-box">
                      <div className="dropdown float-end">
                        <Link to="" className="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown"
                          aria-expanded="false">
                          <i className="mdi mdi-dots-vertical"></i>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">

                          <Link to="" className="dropdown-item">Action</Link>

                          <Link to="" className="dropdown-item">Another action</Link>

                          <Link to="" className="dropdown-item">Something else</Link>

                          <Link to="" className="dropdown-item">Separated link</Link>
                        </div>
                      </div>

                      <h4 className="header-title mt-0 mb-3 text-primary-2">Upcoming</h4>

                      <ul className="sortable-list list-unstyled taskList" id="upcoming">
                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox" id="singleCheckbox2"
                                  value="option2" aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <span className="badge bg-danger float-end">Urgent</span>
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">Improve
                                animation loader</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox" id="singleCheckbox3"
                                  value="option3" aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <span className="badge bg-warning float-end">High</span>
                              <h5 className="mt-0"><Link to="/" className="text-dark">Write a release note for
                                Admin v1.5</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="/" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="/" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="/" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox" id="singleCheckbox4"
                                  value="option4" aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">Invite
                                user to a project</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>


                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox" id="singleCheckbox5"
                                  value="option2" aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <span className="badge bg-danger float-end">Urgent</span>
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">Code HTML
                                email template for welcome email</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>

                      </ul>

                      <div className="text-center pt-2">
                        <Link to='' data-bs-toggle="modal" data-bs-target="custom-modal"
                          onClick={handleOpen}
                          className="btn-2 btn-2-primary waves-effect waves-light" data-animation="fadein"
                          data-overlayspeed="200">
                          <i className="mdi mdi-plus"></i> Add New
                        </Link>
                      </div>
                    </div>
                  </div>

                </div>{/* end col */}


                <div className="col-xl-4">
                  <div className="card">
                    <div className="card-body taskboard-box">
                      <div className="dropdown float-end">
                        <Link to="" className="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown"
                          aria-expanded="false">
                          <i className="mdi mdi-dots-vertical"></i>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">

                          <Link to="" className="dropdown-item">Action</Link>

                          <Link to="" className="dropdown-item">Another action</Link>

                          <Link to="" className="dropdown-item">Something else</Link>

                          <Link to="" className="dropdown-item">Separated link</Link>
                        </div>
                      </div>

                      <h4 className="header-title mt-0 mb-3 text-warning">In Progress</h4>

                      <ul className="sortable-list list-unstyled taskList" id="inprogress">
                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success">
                                <input className="form-check-input" type="checkbox" id="singleCheckbox6"
                                  value="option6" aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <span className="badge bg-danger float-end">Urgent</span>
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">File
                                Uploads on cards</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox" id="singleCheckbox7"
                                  value="option7" aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <span className="badge bg-warning float-end">High</span>
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">Enable
                                analytics tracking</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>


                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox" id="singleCheckbox8"
                                  value="option8" aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">Improve
                                animation loader</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>

                      </ul>

                      <div className="text-center pt-2">
                        <Link data-bs-toggle="modal" data-bs-target="custom-modal"
                          onClick={handleOpen}
                          className="btn-2 btn-2-primary waves-effect waves-light" data-animation="fadein"
                          data-overlayspeed="200" data-overlaycolor="36404a">
                          <i className="mdi mdi-plus"></i> Add New
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>{/* end col */}


                <div className="col-xl-4">
                  <div className="card">
                    <div className="card-body taskboard-box">
                      <div className="dropdown float-end">
                        <Link to="" className="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown"
                          aria-expanded="false">
                          <i className="mdi mdi-dots-vertical"></i>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">

                          <Link to="" className="dropdown-item">Action</Link>

                          <Link to="" className="dropdown-item">Another action</Link>

                          <Link to="" className="dropdown-item">Something else</Link>

                          <Link to="" className="dropdown-item">Separated link</Link>
                        </div>
                      </div>

                      <h4 className="header-title mt-0 mb-3 text-success">Complete</h4>

                      <ul className="sortable-list list-unstyled taskList" id="completed">
                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox"
                                  id="singleCheckbox10" value="option10"
                                  aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <span className="badge bg-danger float-end">Urgent</span>
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">Improve
                                animation loader</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li> +
                              </ul>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox"
                                  id="singleCheckbox11" value="option11"
                                  aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <span className="badge bg-warning float-end">High</span>
                              <h5><Link to="/task/task-details" className="text-dark">Write a release note
                                for Admin v1.5</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>


                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success  float-start">
                                <input className="form-check-input" type="checkbox"
                                  id="singleCheckbox12" value="option12"
                                  aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">Invite
                                user to a project</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>


                        <li>
                          <div className="task-box">
                            <div className="checkbox-wrapper float-start">
                              <div className="form-check form-check-success ">
                                <input className="form-check-input" type="checkbox"
                                  id="singleCheckbox13" value="option13"
                                  aria-label="Single checkbox Two" />
                                <label></label>
                              </div>
                            </div>

                            <div className="task-detail">
                              <span className="badge bg-danger float-end">Urgent</span>
                              <h5 className="mt-0"><Link to="/task/task-details" className="text-dark">Code HTML
                                email template for welcome email</Link> </h5>
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Username">
                                    <img src={Profile} alt="img"
                                      className="avatar-sm rounded-circle" />
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="5 Tasks">
                                    <i className="mdi mdi-format-align-left"></i>
                                  </Link>
                                </li>
                                <li className="list-inline-item">
                                  <Link to="" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="3 Comments">
                                    <i className="mdi mdi-comment-outline"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>

                      </ul>

                      <div className="text-center pt-2">
                        <Link className="btn-2 btn-2-primary waves-effect waves-light" to='' onClick={handleOpen}

                        >
                          <i className="mdi mdi-plus"></i> Add New
                        </Link>
                      </div>
                    </div>
                  </div>

                </div>{/* end col */}

              </div>{/* end row */}

            </div> {/* container */}
          </div> {/* content */}
        </div>

      </Box>
      {/* Modal  */}
      <CustomModal handleClose={handleClose} handleOpen={handleOpen} open={open} />
    </section>
  )
}

export default Task;

